export const INITIAL_STATE = {
  notebook: {
    title: '',
    description: ''
  },
  showLevelModal: true,
  levelData: null,
  protocolSection: {scene: {}},
  sections: [],
  currentSection: null,
  notebookCollapsed: true,

  showLevelSelector: true,
  menuList: [],
  currentChapter: undefined,
  designChapter: undefined,
  drawerCollapsed: true
};